import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  checkInputContainer: {
    display: 'flex',
    gap: '40px',
    marginBottom: '16px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '10px'
    }
  },

  container: {
    display: 'flex',
    gap: 24,

    '& div': {
      width: '100%'
    },

    [theme.breakpoints.down('sm')]: {
      gap: 0,
      flexDirection: 'column'
    }
  },

  section: {
    marginTop: 40
  },

  sectionTitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    borderBottom: '1px solid #E5E5E5',
    fontSize: '18px',
    width: '100%',
    padding: '0 0 8px',
    marginBottom: '16px',
    marginTop: '-18px'
  },

  inputContainer: {
    marginTop: 20
  },

  gridContainerThreeColumns: {
    marginTop: 8,

    [theme.breakpoints.up('sm')]: {
      columnGap: 24,
      rowGap: 0,
      '& > .MuiGrid-item.MuiGrid-grid-sm-4': {
        maxWidth: 'calc(33.3333% - 16px)',
        flexBasis: 'calc(33.3333% - 16px)'
      }
    }
  },

  gridContainerTwoColumns: {
    marginTop: 8,

    [theme.breakpoints.up('sm')]: {
      columnGap: 24,
      rowGap: 0,
      '& > .MuiGrid-item.MuiGrid-grid-sm-6': {
        maxWidth: 'calc(50% - 12px)',
        flexBasis: 'calc(50% - 12px)'
      }
    }
  }
}))
